// Drives the loading state of the cart drawer upsell card and hides it once its
// product is in the cart.
//
// Adding from the card only makes the theme re-render the line items, so the card
// would otherwise linger until the next full page load. The cart is polled rather
// than hooked into the theme's cart-update event because that event does not fire
// reliably on this add path. The same poll ends the spinner, which the theme does
// not toggle for this button. Clicks are delegated from the document since the
// drawer markup gets re-inserted client side.
(function () {
  var CARD_SELECTOR = '.luuf-cart-upsell';
  var BUTTON_SELECTOR = '.luuf-cart-upsell__btn';
  var POLL_INTERVAL = 500;
  var POLL_ATTEMPTS = 20;

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function cartContains(variantId) {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return (cart.items || []).some(function (item) {
          return item.id === variantId;
        });
      })
      .catch(function () {
        return false;
      });
  }

  // The button is left enabled: disabling it inside the click handler would cancel
  // the form submission the theme relies on. The loading class doubles as the guard.
  function setLoading(button, isLoading) {
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function removeWhenAdded(card, button) {
    var variantId = Number(card.dataset.variantId);
    if (!variantId) return;

    var attempts = 0;

    (function poll() {
      attempts += 1;

      cartContains(variantId).then(function (added) {
        if (added) {
          card.remove();
        } else if (attempts < POLL_ATTEMPTS) {
          setTimeout(poll, POLL_INTERVAL);
        } else {
          setLoading(button, false);
        }
      });
    })();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button || button.classList.contains('loading')) return;

    var card = button.closest(CARD_SELECTOR);
    if (!card) return;

    setLoading(button, true);
    removeWhenAdded(card, button);
  });
})();
